import fp from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputSlider from 'react-input-slider';
import { position } from 'polished';
import { color } from '@deerplusofficial/pos-helper';

const Container = styled.div`
  display: ${props => (props.hide ? 'none' : 'flex')};
`;

const TimeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  width: 25%;
  font-style: italic;
  font-size: 36px;
  font-weight: bold;
  color: ${color.text.secondary};
`;

const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-grow: 1;
  padding-left: 24px;
`;

const RangeSlider = styled(InputSlider)`
  position: relative;
  height: 4px;
  background-color: ${color.border};
  border-radius: 5px;
  cursor: pointer;
  touch-action: none;

  .value {
    position: absolute;
    top: 0;
    height: 100%;
    background-color: ${color.primary};
    border-radius: 5px;
  }

  .handle {
    position: absolute;
    width: 0;
    height: 100%;
    &::after {
      display: block;
      content: '';
      width: 12px;
      height: 12px;
      background-color: ${color.primary};
      border-radius: 50%;
      transform: translate(-50%, -50%);
      ${position('absolute', '50%', null, null, '0')};
    }
  }
`;

class Time extends Component {
  static propTypes = {
    onMomentChange: PropTypes.func,
    hide: PropTypes.bool,
  };

  static defaultProps = {
    onMomentChange: fp.identity,
    hide: false,
  };

  get hours() {
    return Number(this.props.moment.format('H'));
  }

  get minutes() {
    return Number(this.props.moment.format('m'));
  }

  onHoursChange = ({ x }) => {
    const { moment, onMomentChange } = this.props;

    onMomentChange(moment.hour(x));
  };

  onMinutesChange = ({ x }) => {
    const { moment, onMomentChange } = this.props;

    onMomentChange(moment.minute(x));
  };

  render() {
    const { moment, hide } = this.props;

    return (
      <Container hide={hide}>
        <TimeWrapper>
          <div>{moment.format('HH')}</div>
          <div>:{moment.format('mm')}</div>
        </TimeWrapper>
        <SliderWrapper>
          <RangeSlider
            xmin={0}
            xmax={23}
            xstep={1}
            x={this.hours}
            onChange={this.onHoursChange}
          />
          <RangeSlider
            xmin={0}
            xmax={59}
            xstep={1}
            x={this.minutes}
            onChange={this.onMinutesChange}
          />
        </SliderWrapper>
      </Container>
    );
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/components/Time/Time.js